import React, { useMemo } from "react";
import { DEFAULT_BLOCK_CSS } from "../../../../constant/constant";
import { useApp } from "../../../../context/AppState";
import { parseCssStringToObject } from "../../../../helper";

const CustomHtmlBlock = ({ section, parentData }) => {
  const { appState, isMobile } = useApp();

  const blockCSS = {
    ...DEFAULT_BLOCK_CSS,
    ...section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"],
    ...parseCssStringToObject(
      section?.setting?.overrideCss?.[isMobile ? "mobile" : "desktop"]
    ),
    position: "relative",
    pointerEvents: appState?.is_preview_mode ? "none" : "auto",
    rotate:
      section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"]?.rotation ??
      `0deg`,
  };

  const contentToDisplay = useMemo(() => {

    const mergeData = { ...parentData };

    const replacePlaceholders = (text, data) => {
      return text.replace(/{{\s*([^{}\s]+)\s*}}/g, (_, key) => {
        const keys = key.split(".");
        let value = data;
        for (const k of keys) {
          value = value?.[isNaN(k) ? k : parseInt(k, 10)];
          if (value === undefined) break;
        }
        return value || "";
      });
    };

    const rawContent = section?.content || "";
    const requiresSellingPlanData =
      /selling_plan|sellingPlanGroups|{{\s*sellingPlanGroups/i.test(rawContent);

    const textToDisplay =
      parentData &&
      requiresSellingPlanData &&
      (!Array.isArray(parentData?.sellingPlanGroups) ||
        parentData.sellingPlanGroups.length === 0)
        ? ""
        : rawContent;
    
    return replacePlaceholders(textToDisplay || "", mergeData);
  }, [section, parentData]);

  return (
    <div
      style={blockCSS}
      dangerouslySetInnerHTML={{ __html: contentToDisplay || "" }}
    />
  );
};

export default React.memo(CustomHtmlBlock);
